import { IConclusion, IConclusionSaveData } from '../../../resource/conclusion/conclusion.types';
import * as conclusionResourceService from '../../../resource/conclusion/conclusion.saga-service';
import * as actions from './conclusions.actions';
import { call, put, select } from 'redux-saga/effects';
import { ISession } from '../../../resource/session/session.types';
import { conclusionsPageSelectors } from './conclusions.selectors';
import { IUser } from '../../../resource/user/user.types';

export function* setupConclusions(sessionId: ISession['id']) {
  const conclusions = (yield call(conclusionResourceService.searchConclusions, sessionId)) as IConclusion['id'][];

  yield put(conclusions ? actions.storeConclusions(conclusions) : actions.clearConclusions());
}

export function* saveConclusion(sessionId: ISession['id'], userId: IUser['id'], conclusionData: IConclusionSaveData) {
  const conclusion = (yield call(
    conclusionResourceService.saveConclusion,
    sessionId,
    userId,
    conclusionData,
  )) as IConclusion;
  if (!conclusion) {
    return;
  }
  const conclusionsIds = (yield select(conclusionsPageSelectors.selectConclusions)) as IConclusion['id'][];
  yield put(conclusionsIds ? actions.storeConclusions([...conclusionsIds]) : actions.clearConclusions());
}

export function* deleteConclusion(sessionId: ISession['id'], userId: IUser['id']) {
  yield call(conclusionResourceService.deleteConclusion, sessionId, userId);

  const conclusionsIds = (yield select(conclusionsPageSelectors.selectConclusions)) as IConclusion['id'][];
  yield put(conclusionsIds ? actions.storeConclusions([...conclusionsIds]) : actions.clearConclusions());
}

export function* handleConclusionFromNotification(conclusion: IConclusion) {
  yield call(conclusionResourceService.storeConclusion, conclusion);
}

export function* handleDeleteConclusionFromNotification(conclusion: IConclusion) {
  yield call(conclusionResourceService.clearConclusion, conclusion.id);

  const conclusionsIds = (yield select(conclusionsPageSelectors.selectConclusions)) as IConclusion['id'][];
  yield put(conclusionsIds ? actions.storeConclusions([...conclusionsIds]) : actions.clearConclusions());
}

export function* clearConclusionsPageStorage() {
  yield put(actions.clearConclusions());
}
